import styled from "@emotion/styled";
export const StyledBypassBlocksMenuComponent = styled.nav`
  .menu-item {
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0;
    pointer-events: none;

    &:focus {
      opacity: 1;
      pointer-events: auto;
      z-index: 10000001;
      background-color: #1f76c2;
      color: #ffffff;
      padding: 12px 24px;
      font-size: 16px;
      font-weight: 600;
      border-radius: 0 0 4px 0;
      outline: 2px solid #ffffff;
      outline-offset: -2px;
      text-decoration: none;
    }
  }
`;
